module.exports = __webpack_public_path__ + "static/media/icon-ui-icons-ic-public.d10be1c8.svg";